// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, Divider } from 'gestalt';

type Props = {|
  children?: any,
|};

const BoardFormList = ({ children }: Props) => (
  <Box role="list">
    {React.Children.map(
      children,
      (child, i) =>
        child && (
          <Box key={i}>
            {child}
            <Divider />
          </Box>
        ),
    )}
  </Box>
);

export default BoardFormList;

BoardFormList.propTypes = {
  children: PropTypes.node,
};
